module.exports = __webpack_public_path__ + "7d0e1fb6de7c81649fff1fc6888839cd.png";